export const BUNDLE_SUMMARY_MODULE_TEST_ID = {
  bundleSummaryHeading: 'bundle-summary-heading',
  bundleSummarySubHeading: 'bundle-summary-sub-heading',
};
